import {RESTproxy} from '../RESTproxy';

export class RetailersProxy extends RESTproxy {
    constructor() {
        super('retailer');
    }
}